import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import ChatMessagesDrawer from "components/drawer/ChatMessagesDrawer";
import Tooltip from "components/tooltip/Tooltip";
import formatDuration from "utils/formatDuration";

// Clicking a chat (the row or the eye icon) opens its conversation in a
// right-side drawer — live if the chat is still going on.
// A page with several tables can pass `selectedChat`/`onSelectChat` to share
// ONE drawer (so it stays open even if the row drops out of a refreshed
// list); on its own the table keeps its own drawer.
const ChatHistoryTable = ({ historydata, selectedChat: sharedSelected, onSelectChat,isAdmin }) => {
  const [ownSelected, setOwnSelected] = useState(null);
  const shared = typeof onSelectChat === "function";
  const selectedChat = shared ? sharedSelected : ownSelected;
  const setSelectedChat = shared ? onSelectChat : setOwnSelected;

  return (
    <>
      {!shared && (
        <ChatMessagesDrawer chat={ownSelected} onClose={() => setOwnSelected(null)} />
      )}
      <TableBody>
        {historydata?.map((data, index) => (
          <TableRow
            key={data.chat_id}
            className={`cursor-pointer hover:bg-gray-50 ${
              selectedChat?.chat_id === data.chat_id ? "bg-green-50" : ""
            }`}
            onClick={() => setSelectedChat(data)}
          >
            <TableCell className="text-center text-xs"> {index + 1}</TableCell>

            <TableCell className="text-center text-xs">
              {data.chat_id}
              {["active", "transferred"].includes(String(data.status || "").toLowerCase()) && (
                <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
                  ● Live
                </span>
              )}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.agent_name}
            </TableCell>
            {isAdmin && <TableCell className="text-center text-xs">
              {data.employee_name}
            </TableCell>
}
            {/* created_at comes as "DD-MM-YYYY HH:MM:SS" — date over time */}
            <TableCell className="text-center text-xs whitespace-no-wrap">
              {data.created_at ? (
                <>
                  <div>{String(data.created_at).split(" ")[0]}</div>
                  <div className="text-gray-500">{String(data.created_at).split(" ")[1] || ""}</div>
                </>
              ) : (
                "-"
              )}
            </TableCell>
            <TableCell className="text-center text-xs">{data.rating}</TableCell>
            <TableCell className="text-center text-xs">
              {formatDuration(data.duration_seconds, data.status)}
            </TableCell>

            <TableCell>
              <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600 text-center">
                <button
                  className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedChat(data);
                  }}
                >
                  <Tooltip Icon={FiEye} title="View Chat" bgColor="#34D399" />
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default ChatHistoryTable;
